import { UnassignFloatingIpBlock } from "@/admin/floating_ips/UnassignFloatingIpBlock.tsx";
import { DeleteVmBlock } from "@/admin/vm/DeleteVmBlock.tsx";
import { MigrateVmBlock } from "@/admin/vm/MigrateVmBlock.tsx";
import { RescueModeVmBlock } from "@/admin/vm/RescueModeVmBlock.tsx";
import { StartVmBlock } from "@/admin/vm/StartVmBlock.tsx";
import { StopVmBlock } from "@/admin/vm/StopVmBlock.tsx";
import { useGetVmItemForAdmin } from "@/admin/vm/useGetVmItemForAdmin.tsx";
import { VmResizeToolbarButton } from "@/admin/vm/VmResizeModal.tsx";
import { link } from "@/components/Action.tsx";
import { WModalButton, WToolButton } from "@/components/button/WToolButton.tsx";
import { Toolbar } from "@/components/Toolbar.tsx";
import { notNull } from "@warrenio/utils/notNull";

export function VmToolbar({ vmUuid, location }: { vmUuid: string; location: string }) {
    const item = useGetVmItemForAdmin(vmUuid, location);
    if (!item) {
        return null;
    }

    const isRunning = item.status === "running";
    const isStopped = item.status === "stopped";
    const isDeleted = item.status === "deleted";

    return (
        <Toolbar>
            <StartVmBlock
                item={item}
                button={<WModalButton isDisabled={isRunning || isDeleted} label="Start" size="md" icon="jp-icon-run" />}
            />
            <StopVmBlock
                item={item}
                button={<WModalButton isDisabled={isStopped || isDeleted} label="Stop" size="md" icon="jp-icon-stop" />}
            />
            <StopVmBlock
                force
                item={item}
                button={
                    <WModalButton
                        isDisabled={isStopped || isDeleted}
                        label="Force Stop"
                        size="md"
                        icon="jp-power-icon"
                    />
                }
            />
            <UnassignFloatingIpBlock
                item={item}
                button={
                    <WModalButton
                        isDisabled={item.ip_address_object === null || isDeleted}
                        label="Unassign IP"
                        size="md"
                        icon="jp-wrong-icon"
                    />
                }
            />
            <WToolButton
                label="Terminal"
                icon="jp-monitor-icon"
                isDisabled={isDeleted}
                action={link({
                    to: "/admin/console/$location/$vmId",
                    params: { location: notNull(item._location), vmId: item.uuid },
                    target: "_blank",
                })}
            />

            <RescueModeVmBlock
                item={item}
                button={<WModalButton label="ISO boot" icon="jp-disc-icon" isDisabled={isRunning || isDeleted} />}
            />

            <VmResizeToolbarButton item={item} />

            <MigrateVmBlock
                item={item}
                button={<WModalButton label="Migrate" isDisabled={isDeleted} size="md" icon="jp-export-icon" />}
            />

            <DeleteVmBlock
                item={item}
                button={<WModalButton label="Delete" isDisabled={isDeleted} size="md" icon="jp-trash-icon" />}
            />
        </Toolbar>
    );
}
